export default (relativeUrl) => `/${relativeUrl.replace(/^\//, '')}`;
